'use client';
const UnpredictedError: React.FC = () => {
  return <div>Error</div>
};

export default UnpredictedError;
